import React from 'react';
import COLORS from '../../styles/colors'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from "react-router-dom";
import Button from '@material-ui/core/Button';
import ButtonContent from './../ButtonContent';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import MenuIcon from '@material-ui/icons/Menu';
import { MIN_DESKTOP_WIDTH } from '../../constants';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

const TopBar = ({currentUser, logout, history, pathname, toggleDrawer}) => {

  //OMG USE HOOKS FOR THE FIRST TIME!!!
  const [anchorEl, setAnchorEl] = React.useState(null);
  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function userLogout() {
    document.querySelector('#simple-menu').remove()
    logout().then(() => {
      let url =`${process.env.REACT_APP_URL}`;
      if (process.env.REACT_APP_ENV === 'prod') {
        url = `${process.env.REACT_APP_CHAT_URL}?logout=${true}&returnUrl=${process.env.REACT_APP_URL}`;
      }
      window.location.href= url;
    });
  }

  const onMoveBuildPage = () => {
    history.push('/build/workout');
  }


  const isMobile = window.innerWidth < MIN_DESKTOP_WIDTH ? true : false;

  return (

      <Toolbar style={{
          display: 'flex',
          justifyContent:'space-between',
          alignItems: 'center',
          borderBottom:'1px solid',
          borderColor: COLORS.grey,
          paddingLeft: 20,
          color: COLORS.black,
          height: 55}}>
          <div>
            { pathname !== '/assign/mobile/clients' &&
              pathname !== '/social/mobile/posts' &&
              pathname !== '/social/mobile/intro'
            &&
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              onClick={toggleDrawer}
              style={{
                marginRight: 20,
                display: isMobile ? 'inline-block' : 'none',
              }}
            >
              <MenuIcon />
            </IconButton>
           }
            <Link to={'/'} >
               <img src='/assets/img/logo.png' alt="" height={50}/>
            </Link>
          </div>

       <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            paddingLeft: 20,
            height: '100%'}} >
                  {(pathname === '/chat' || pathname === '/social/posts') &&
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={onMoveBuildPage}
                      style={{
                        backgroundColor: COLORS.orange
                      }}
                    >
                    <ButtonContent
                      text="Dashboard" />
                  </Button>
                  }
        {  pathname !== '/assign/mobile/clients' &&
           pathname !== '/social/mobile/posts' &&
           pathname !== '/social/mobile/intro'
         &&
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            paddingLeft: 20,
            borderLeft: '1px solid ' + COLORS.grey,
            marginLeft: '15px',
            height: '100%'}}>
            {
              currentUser.isAuthenticated  ? (
                <div>



                  <div onClick={handleClick} className="link">
                    My Admin Profile
                    <FontAwesomeIcon icon="chevron-down" style={{marginLeft: 5}}/>
                  </div>
                  <Menu
                     id="simple-menu"
                     anchorEl={anchorEl}
                     keepMounted
                     open={Boolean(anchorEl)}
                     onClose={handleClose}
                   >
                    <Link to="/settings/edit-profile">
                      <MenuItem onClick={handleClose}>
                        Settings
                      </MenuItem>
                    </Link>
                     <MenuItem onClick={userLogout}>
                       <a>
                         Logout
                       </a>
                     </MenuItem>
                   </Menu>
                </div>
              ): (
                <Link to="signin" >
                  Sign In
                </Link>
              )
            }

        </div>
        }
        </div>
      </Toolbar>
  );
}

export default TopBar



// WEBPACK FOOTER //
// ./src/components/nav/TopBar.js